const VALIDATE_ALL_DATA = 'ColumnDataValidationMode_ValidateAllData'
const VALIDATE_PARTIAL_DATA = 'ColumnDataValidationMode_ValidatePartialData'
const NO_VALIDATION = 'ColumnDataValidationMode_NoValidation'

const columnDataValidationModeDescriptions = {
  [VALIDATE_ALL_DATA]: {
    name: 'Strict',
    description: 'All rows must have values',
  },
  [VALIDATE_PARTIAL_DATA]: {
    name: 'Partial',
    description: 'At least one row must have a value',
  },
  [NO_VALIDATION]: {
    name: 'None',
    description: 'No validation will be performed',
  },
}

export {
  VALIDATE_ALL_DATA,
  VALIDATE_PARTIAL_DATA,
  NO_VALIDATION,
  columnDataValidationModeDescriptions,
}
